import { Col, Form, FormInstance, Row } from 'antd';
import ByMovimentsCheckBoxs from './ByMovimentsCheckBoxs';
import ByMovimentsRadioGroups from './ByMovimentsRadioGroups';
import ByMovimentsSelectReportType from './ByMovimentsSelectReportType';
import ReportSelectMonthFields from '@/components/_common/ReportSelectMonthFields';
import ByMovimentsMoreOptions from './ByMovimentsMoreOptions';
import {
  CommissionByMovementFormValues,
  CommissionByMovementReportType,
} from '@/core/domain/questReport/Reports/CommssionByMovement/CommissionByMovement.types';

interface Props {
  form: FormInstance<CommissionByMovementFormValues>;
}

const CommissionByMovimentsForm: React.FC<Props> = ({ form }) => {
  const watchType = Form.useWatch('reportType', form);
  return (
    <Form layout="vertical" form={form}>
      <ReportSelectMonthFields
        form={form}
        dateFilter={<ByMovimentsRadioGroups form={form} />}
      />

      <Row gutter={[24, 24]}>
        <Col xs={24}>
          <ByMovimentsCheckBoxs
            isPaintedType={
              watchType === CommissionByMovementReportType.paintedPart
            }
          />
        </Col>

        <Col xs={24}>
          <ByMovimentsSelectReportType />
        </Col>

        <Col xs={24}>
          <ByMovimentsMoreOptions />
        </Col>
      </Row>
    </Form>
  );
};

export default CommissionByMovimentsForm;
